import {
  IconMapPin,
  IconEye,
  IconStar,
  IconStarFilled,
  IconClipboardCheck,
} from "@tabler/icons-react";
// import { themeFor, initialsFor, nairaFmt, modeIconFor } from './data/talentsData';
import styles from "../Feed.module.css";
import {
  currencyFormat,
  initialsFor,
  modeIconFor,
  themeFor,
} from "../../../../utils/functions";
import { useNavigate } from "react-router";

const TalentRow = ({
  id,
  role,
  location,
  workMode,
  highestCompensation,
  lowestCompensation,
  jobType,
  psychometric,
  onToggleStar,
  load,
  handleRemoveShortlist,
  handleShortlist,
  starredIds,
  setStarredIds,
  isShortlist,
  isShortlisted,
}) => {
  const theme = themeFor(role);
  const navigate = useNavigate();

  const onView = () => {
    if (!id) return;
    isShortlist
      ? navigate(`/talent-profile/review/${id}?isShortlist=true`)
      : navigate(`/talent-profile/review/${id}?advanced-search=true`);
  };

  return (
    <div
      className={styles.row}
      onClick={() => {
        onView(id);
      }}
    >
      <div
        className={`${styles.mono} ${styles.rowAvatar}`}
        style={{ background: theme.bg, color: theme.fg }}
      >
        {initialsFor(role)}
      </div>

      <div className={styles.rowMain}>
        <div className={styles.rowRole}>
          <span className={styles.rowRoleText}>{role}</span>
          {psychometric && (
            <span className={styles.psychBadge}>
              <IconClipboardCheck size={11} /> Psychometric
            </span>
          )}
        </div>
        <div className={styles.rowMeta}>
          <span className={styles.rowLoc}>
            <IconMapPin size={13} /> {location}
          </span>
          <span className={styles.rowDot} />
          <span className={styles.rowJobtype}>{jobType}</span>
          {workMode?.length > 0 && (
            <span className={styles.rowModes}>
              {workMode?.map((m) => {
                const ModeIcon = modeIconFor(m);
                return (
                  <span key={m} className={styles.modeChip}>
                    <ModeIcon size={12} /> {m}
                  </span>
                );
              })}
            </span>
          )}
        </div>
        <div className={styles.rowPayInline}>
          &#8358;{currencyFormat(Number(lowestCompensation ?? 0))}{" "}
          <span>-</span> &#8358;
          {currencyFormat(Number(highestCompensation ?? 0))}
        </div>
      </div>

      <div className={styles.rowRight}>
        <div className={styles.rowPay}>
          <div className={styles.rowPayLabel}>Expected pay</div>
          <div className={styles.rowPayVal}>
            &#8358;{currencyFormat(Number(lowestCompensation ?? 0))}{" "}
            <span>-</span> &#8358;
            {currencyFormat(Number(highestCompensation ?? 0))}
          </div>
        </div>
        <div className={styles.rowActions}>
          <button
            className={`${styles.iconBtn} ${styles.starBtn} ${isShortlisted || starredIds[id] ? styles.starBtnActive : ""}`}
            onClick={(e) => {
              e.stopPropagation();
              onToggleStar(id);
            }}
            disabled={load}
            aria-label={
              isShortlisted ? "Remove from shortlist" : "Add to shortlist"
            }
            title={isShortlisted ? "Remove from shortlist" : "Add to shortlist"}
          >
            {isShortlisted ? (
              <span
                disabled={load}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  handleRemoveShortlist(id);
                }}
              >
                <IconStarFilled size={18} />
              </span>
            ) : (
              <span
                disabled={load}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  setStarredIds((prev) => ({ ...prev, [id]: true }));
                  if (isShortlisted) {
                    handleRemoveShortlist(id);
                  } else {
                    handleShortlist(id).catch(() => {
                      setStarredIds((prev) => ({
                        ...prev,
                        [id]: false,
                      }));
                    });
                  }
                }}
              >
                {starredIds[id] || isShortlisted ? (
                  <IconStarFilled size={18} />
                ) : (
                  <IconStar size={18} />
                )}
              </span>
            )}
          </button>
          <button
            className={styles.iconBtn}
            onClick={(e) => {
              e.stopPropagation();
              onView(id);
            }}
            aria-label="View profile"
            title="View profile"
          >
            <IconEye size={18} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default TalentRow;
